export const transformStatusDto = status => {
  const {
    id,
    title,
    description,
    explanation,
    order
  } = status;
  return {
    id,
    title,
    description,
    order,
    explanation: {
      title: status.explanation_title,
      body: explanation
    },
    isDefault: !!status.is_default
  };
};
export const transformStatusDtos = statuses => statuses.map(transformStatusDto);